import { G_APP_NAME } from "@/constants";

export const translationsSl = {
  lmMainBrandName: G_APP_NAME,
  appVersionTitle: "Različica",
  appMaxCanvasTitle: "Faktor predloge",
  appMaxCanvasSize: "Največja velikost",
  appErrorTitle: "Napaka",
  appWarningTitle: "Opozorilo",
  // COUNTRIES
  cSloveniaName: "Slovenija",
  cCroatiaName: "Hrvaška",
  // DAYSOFWEEK
  dayMonday: "ponedeljek",
  dayTuesday: "torek",
  dayWednesday: "sreda",
  dayThursday: "četrtek",
  dayFriday: "petek",
  daySaturday: "sobota",
  daySunday: "nedelja",
  // MONTHS
  yearStr: "Leto",
  monthStr: "Mesec",
  monthJanuary: "Januar",
  monthFebruary: "Februar",
  monthMarch: "Marec",
  monthApril: "April",
  monthMay: "Maj",
  monthJune: "Junij",
  monthJuly: "Julij",
  monthAugust: "Avgust",
  monthSeptember: "September",
  monthOctober: "Oktober",
  monthNovember: "November",
  monthDecember: "December",
  // BUTTONS COMMON
  lmBtnRemove: "Odstrani",
  lmBtnPreview: "Predogled",
  lmBtnDelete: "Izbriši",
  lmBtnCrop: "Izreži",
  lmBtnCropAgain: "Ponovi izrez",
  lmBtnReset: "Reset",
  lmBtnApply: "Uveljavi",
  lmBtnCancel: "Prekliči",
  lmBtnSelect: "Izberi",
  lmBtnDesign: "Oblikuj",
  lmBtnSend: "Pošlji",
  lmBtnAdd: "Dodaj",
  lmBtnAddBatch: "Dodaj več",
  lmBtnClose: "Zapri",
  lmBtnSave: "Shrani",
  lmBtnBack: "Nazaj",
  lmBtnNext: "Naprej",
  lmBtnConfirm: "Potrdi",
  lmBtnReply: "Odgovori",
  lmBtnNewMessage: "Novo sporočilo",
  lmBtnSignOut: "Odjavi se",
  lmBtnAgree: "Strinjam se",
  lmBtnYes: "Da",
  lmBtnNo: "Ne",
  lmBtnAllow: "Privoli",
  lmStep: "Korak",
  lmPleaseWait: "Prosim, počakajte ...",
  lmPcs: "kom",
  lmDays: "dni",
  lmMax: "največ",
  lmWidthCustomSize: "Širina v cm (npr. 6 ali 7.8)",
  lmHeightCustomSize: "Višina v cm (npr. 6 ali 7.8)",
  lmLastDay: "Zadnji dan",
  msgConfirm: "Potrditev",
  msgQuestion: "Vprašanje",
  msgAdvice: "Nasvet",
  msgError: "Napaka",
  msgAddedTitle: "dodano",
  msgHelpTitle: "Pomoč",
  msgMore: "Več",
  msgUnderstand: "Razumem",
  msgSet: "Spremeni",
  msgShow: "Prikaži",
  msgAll: "Vse",
  msgShowAll: "Prikaži vse",
  msgSelectAll: "Izberi vse",
  msgSelectDoneOlder: "Izberi zaključene (7dni+)",
  msgDeselectAll: "Počisti izbor",
  msgEditText: "Vnesi besedilo",
  msgNoText: "<prazno>",
  msgPage: "Stran",
  settingsNotifyEmailText: "Email za obveščanje (več naslovov ločite z ;)",
  msgRecordLastAddedEdited: "Ustvarjeno / Zadnji popravek",
  msgInventory: "Zaloga",
  msgInventoryLastPcs: "Zadnji kosi",
  msgInventoryLastPiece: "Zadnji kos",
  msgInventorySoldOut: "Trenutno ni na zalogi",
  msgInventoryAvailable: "Na zalogi",
  fileNamePackageImages: "Slike", // za v ime zip fajla, ne sme biti presledkov
  fileNamePackageItems: "Izdelki", // za v ime zip fajla, ne sme biti presledkov
  askSimpleImageDelete: "Ali resnično želite izbrisati to sliko?",
  warningEnableSmallDevices:
    "Zaradi velikosti predloge je ta izdelek možno naročiti le iz osebnega računalnika. Hvala za razumevanje.",
  errorGeneratingGiftImages:
    "Napaka pri generiranju slik zaradi premalo pomnilnika. Nalaganje paketa ni bilo uspešno.",
  // DIALOG PIXABAY IMAGE DATABASE SELECTION
  dialogPixabayImageTypeAll: "Vse vrste",
  dialogPixabayImageTypeImages: "Slike",
  dialogPixabayImageTypeIllustrations: "Ilustracije",
  dialogPixabayImageTypeVectors: "Vektorske",
  dialogPixabayImageOrientationAll: "Vse postavitve",
  dialogPixabayImageOrientationLandscape: "Ležeče",
  dialogPixabayImageOrientationPortrait: "Pokončne",

  dialogPixabayImageCategoryAll: "Vse kategorije",
  dialogPixabayImageCategoryBackgrounds: "Ozadja",
  dialogPixabayImageCategoryNature: "Narava",
  dialogPixabayImageCategoryFeelings: "Čustva",
  dialogPixabayImageCategoryAnimals: "Živali",
  dialogPixabayImageCategoryFashion: "Moda",
  dialogPixabayImageCategoryMusic: "Glasba",
  dialogPixabayImageCategorySports: "Šport",
  dialogPixabayImageCategoryScience: "Znanost",
  dialogPixabayImageCategoryEducation: "Izobraževanje",
  dialogPixabayImageCategoryHealth: "Zdravje",
  dialogPixabayImageCategoryPeople: "Ljudje",
  dialogPixabayImageCategoryReligion: "Vera",
  dialogPixabayImageCategoryPlaces: "Kraji",
  dialogPixabayImageCategoryIndustry: "Industrija",
  dialogPixabayImageCategoryComputer: "Računalništvo",
  dialogPixabayImageCategoryFood: "Hrana",
  dialogPixabayImageCategoryTransportation: "Transport",
  dialogPixabayImageCategoryTravel: "Potovanja",
  dialogPixabayImageCategoryBuildings: "Zgradbe",
  dialogPixabayImageCategoryBusiness: "Posel",

  dialogPixabayImageColorAll: "Vse barve",
  dialogPixabayImageColorGrayscale: "Črnobela",
  dialogPixabayImageColorRed: "Rdeča",
  dialogPixabayImageColorOrange: "Oranžna",
  dialogPixabayImageColorYellow: "Rumena",
  dialogPixabayImageColorGreen: "Zelena",
  dialogPixabayImageColorTurquoise: "Turkizna",
  dialogPixabayImageColorBlue: "Modra",
  dialogPixabayImageColorLilac: "Lila",
  dialogPixabayImageColorPink: "Roza",
  dialogPixabayImageColorWhite: "Bela",
  dialogPixabayImageColorGray: "Siva",
  dialogPixabayImageColorBlack: "Črna",
  dialogPixabayImageColorBrown: "Rjava",

  // DIALOG IMAGE DATABASE SELECTION
  dialogImageDatabaseSelectionOrderBy: "Prikaži najprej",
  dialogImageDatabaseSelectionOrderByAddition: "najnovejše",
  dialogImageDatabaseSelectionOrderByPopularity: "najpopularnejše",
  dialogImageDatabaseSelectionStickersType: "Tip nalepke",
  dialogImageDatabaseSelectionStickersTypeAll: "Vse nalepke",
  dialogImageDatabaseSelectionStickersTypeImages: "Slikovne nalepke",
  dialogImageDatabaseSelectionStickersTypeLang:
    "Besedilne nalepke v angleščini",
  dialogImageDatabaseSelectionStickersTypeCurrentLang:
    "Besedilne nalepke v mojem jeziku",
  dialogImageDatabaseSelectionStickersTypeCustomBtn: "Uvozi",
  dialogImageDatabaseSelectionStickersTypeCustomBtnLong: "Uvozi lastno nalepko",
  // FABRIC CONTROLS
  fabricAddTextButton: "Besedilo",
  fabricAddImageButton: "Slika",
  fabricChangeTemplateButton: "Predloga",
  fabricChangeTemplateDialogTitle: "Zamenjajte predlogo",
  fabricSelectTemplateDialogTitle: "Izberite predlogo",
  fabricSelectStickerDialogTitle: "Izberite nalepko",
  fabricSelectImageBackgoundDialogTitle: "Izberite ozadje",
  fabricImageFilterBase: "Slikovni filter",
  fabricImageFilterGrayscale: "Grayscale",
  fabricImageFilterVintage: "Vintage",
  fabricImageFilterBrownie: "Brownie",
  fabricImageFilterSephia: "Sephia",
  fabricImageFilterKodachrome: "Kodachrome",
  fabricImageFilterNoFilter: "Brez",
  fabricColorPickerTitle: "Izberite barvo",
  fabricDialogPreviewTitle: "Predogled",
  fabricDialogPreviewOnItemTitle: "Predogled na izdelku",
  fabricDialogPreviewImageTitle: "Vaša slika",
  fabricColorPickerActivateGradientTitle: "Ustvari barvni preliv",
  fabricBackgroundImageGroupControlsBackTitle: "nazaj",
  fabricBackgroundImageGroupControlsMenuTitle: "menu",
  fabricBackgroundImageGroupControlsTitle: "filtri ozadja",
  fabricImageFiltersGroupControlsTitle: "filtri slike",
  fabricElementsGroupControlsTitle: "dodajanje elementov",
  fabricBackgroundGroupControlsTitle: "slika",
  fabricBackgroundGroupControlsBackgroundTitle: "ozadje",
  fabricZoomGroupControlsTitle: "zoom",
  fabricZoomGroupControlsSubTitle: "nastavi",
  fabricImageGroupControlsTitle: "slika",
  fabricPreviewGroupControlsTitle: "predogled",
  fabricBorderGroupControlsTitle: "okvir",
  fabricTextOutlineGroupControlsTitle: "obroba",
  fabricRadiusGroupControlsTitle: "radij",
  fabricSimpleFrameGroupControlsTitle: "okvir",
  fabricTextStyleGroupControlsTitle: "stil & ozadje",
  fabricBackgroundImageAddImageTitle: "Moja slika",
  fabricBackgroundImageAddCollageTitle: "Dodaj več slik v kolaž",
  fabricBackgroundImageAddBackgroundTitle: "Izberi ozadje",
  fabricBackgroundImageAddPixabayBackgroundTitle: "Izberi Pixabay ozadje",
  fabricBackgroundImageAddPixabayPatternTitle: "Izberi Pixabay vzorec",
  fabricBackgroundImageAddPatternTitle: "Izberi vzorec",
  fabricBackgroundImageAddFrameTitle: "Izberi okvir",
  fabricBackgroundImageAddColorTitle: "Izberi barvo",
  fabricBackgroundImageResetBackgroundTitle: "Odstrani ozadje",
  fabricBackgroundImageStartBackgroundTitle: "Začetno ozadje",
  fabricBackgroundImageShowFilters: "Filtri ozadja",
  fabricZoomBackTitle: "nazaj",
  fabricZoomEditBackTitle: "urejanje",
  fabricZoomMainControlsTitle: "nastavi povečavo",
  fabricZoomMainControlsInTitle: "povečaj",
  fabricZoomMainControlsOutTitle: "pomanjšaj",
  fabricZoomMainControlsDefaultTitle: "reset",
  fabricFreeDrawingApply: "uveljavi",
  fabricFreeDrawingCancel: "prekliči",
  fabricFreeDrawingBrush: "čopič",
  fabricFreeDrawingShadow: "senca",
  fabricTextFont: "pisava",
  fabricTextFunction: "Vrsta besedila",
  fabricTextFunctionNormal: "Običajno besedilo",
  fabricTextFunctionGiftCardFull: "Darilni bon (napis koda | napis cena | napis veljavnost)",
  fabricTextFunctionGiftCardFullShort: "Darilni bon (koda | cena | veljavnost)",
  fabricTextFunctionGiftCardCodeValidTo: "Darilni bon (napis koda | napis veljavnost)",
  fabricTextFunctionGiftCardCodeValidToShort: "Darilni bon (koda | veljavnost)",
  fabricTextFunctionGiftCardFullCode: "Darilni bon (napis koda)",
  fabricTextFunctionGiftCardFullPrice: "Darilni bon (napis cena)",
  fabricTextFunctionGiftCardFullValidTo: "Darilni bon (napis veljavnost)",
  fabricTextFunctionGiftCardCode: "Darilni bon (koda)",
  fabricTextFunctionGiftCardPrice: "Darilni bon (cena)",
  fabricTextFunctionGiftCardPriceOnly: "Darilni bon (samo cena)",
  fabricTextFunctionGiftCardValidTo: "Darilni bon (veljavnost)",
  fabricTextFunctionGiftCardUserCode: "Koda",
  fabricTextFunctionGiftCardUserPrice: "Vrednost",
  fabricTextFunctionGiftCardUserPriceOn: "prikaži",
  fabricTextFunctionGiftCardUserPriceOff: "skrij",
  fabricTextFunctionGiftCardUserValidTo: "Veljavnost",
  fabricAllowDelete: "Dovoli odstranitev",
  fabricAllowManipulate: "Dovoli manipulacijo",
  fabricAllowReplace: "Kategorja zamenjave",
  fabricAllowEdit: "Dovoli urejanje",
  fabricRemoveOverlay: "Odstrani ob zaključku",
  fabricPreviewImage: "slika",
  fabricPreviewItem: "izdelek",
  fabricPreviewBackground: "izberi",
  fabricAddImage: "okvir",
  fabricAddFrame: "Dodaj sliko v naprednem okvirju",
  fabricAddSimpleFrame: "Dodaj sliko v pravokotnem okvirju",
  fabricAddSimpleFrame2: "Dodaj sliko v okroglem okvirju",
  fabricAddCollage: "Dodaj več slik v kolaž",
  fabricAddSticker: "nalepka",
  fabricAddText: "besedilo",
  fabricAddFree: "risanje",
  fabricFiltersFilter: "filter",
  fabricFiltersBrightness: "svetlost",
  fabricFiltersBlur: "zameglitev",
  fabricFiltersContrast: "kontrast",
  fabricFiltersReset: "reset",
  fabricTextOutlineWidth: "debelina",
  fabricTextOutlineColor: "barva",
  fabricTextFontName: "font",
  fabricTextFontColor: "barva",
  fabricTextMagicStyle: "stil",
  fabricTextStyleAlign: "poravnava",
  fabricTextStyleBackgroundColor: "ozadje",
  fabricFreeHandChanges: "spremembe",
  // FORM VALIDATION COMMON
  frmValidationRequiredField: "Vnos podatka je obvezen",
  frmValidationStringTooLongField: "Vnos znakov je predolg",
  frmValidationNumberTooBigField: "Vnesli ste preveliko številko",
  frmValidationNotCurrencyField: "Vnesite znesek npr. 4 ali 3.50",
  frmValidationNotPctField: "Vnesite procent med 0 in 999",
  frmValidationNotNumberField: "Vnesite veljavno številko",
  // FLAG SELECTION
  lmFlagSelectBtnTitle: "Jezik",
  // DATA GRID COMMON
  dataGridRowPage: "Stran",
  dataGridRowsPerPageText: "Zapisov na stran",
  dataGridRowsPerPageAllText: "Vse",
  dataGridRowsPageText: "od",
  dataGridSearchLabel: "Iskanje",
  dataGridPixabaySearchLabel: "Vpišite iskalni niz v angleščini",
  dataGridSlotNoData: "Ni podatkov za prikaz.",
  dataGridSlotNoResults: "Iskanje ni vrnilo zapisov.",
  // ADD EDIT FORM COMMON
  addEditFormAddingTitle: "Dodajanje zapisa",
  addEditFormEditingTitle: "Popravljanje zapisa",
  addEditFormSaveButton: "Shrani",
  addEditFormCloseButton: "Zapri",
  addEditFormBackButton: "Nazaj",
  addEditFormCancelButton: "Prekliči",
  // DIALOGCUSTOMSIZE
  dialogCustomSizeTitle: "Vpišite dimenzije slike",
  dialogCustomSizeZeroError: "Širina in višina morata biti večja od 0.",
  // DIALOG COMMON
  deleteDialogTitle: "Brisanje podatkov",
  deleteDialogQuestion: "Ali ste prepričani, da želite izbrisati ta zapis?",
  deleteDialogImageQuestion:
    "Ali ste prepričani, da želite izbrisati to sliko?",
  deleteDialogQuestionWarning:
    "POZOR! Ob brisanju tega zapisa boste izbrisali tudi vse povezane zapise.",
  deleteDialogQuestionWarning2:
    "POZOR! Ta zapis je povezan z zapisi iz drugih tabel. Ob brisanju tega zapisa bodo povezani zapisi izgubili aktivno povezavo.",
  // COMMON MESSAGES
  msgSuccessSaveRefresh:
    "Shranjeno. Spremembe bodo vidne ob naslednjem nalaganju. Osvežite stran.",
  msgSuccessDelete: "Zapis je bil izbrisan.",
  msgActionError: "Akcija ni bila uspešna.",
  msgSuccessImageDelete: "Slika je bila izbrisana.",
  msgErrorImageDelete: "Slika ni bila izbrisana.",
  msgSuccessEdit: "Zapis je bil popravljen.",
  msgSuccessAdd: "Zapis je bil dodan.",
  msgErrorSave: "Napaka pri shranjevanju zapisa.",
  msgSelectPicture: "Izberi sliko",
  msgPropUpdateText: "Dopolni",
  msgWelcomeText: "Dobrodošli",
  msgNotification: "Obvestilo",
  // FORM COMMON
  lmFrmEmail: "E-mail",
  lmFrmDisplayName: "Naziv",
  lmFrmErrorRequiredField: "Vnos tega podatka je obvezen",
  lmFrmErrorFormatField: "Vpisani podatek je napačen",
  lmFrmErrorWidthLessThanHeightField:
    "Širina mora biti večja ali enaka višini slike (ležeča postavitev)",
  lmFrmErrorMaxCustomSizeField:
    "Vnesli ste preveliko dimenzijo slike. Prosim popravite vnos.",
  lmFrmErrorFormatPasswordField: "Geslo mora biti dolžine vsaj 5 znakov",
  lmFrmEnterEmail: "Vpišite elektronski naslov",
  lmFrmEnterPass: "Vpišite geslo",
  lmFrmEnterPassError: "Vpisano geslo je napačno.",
  // FORM LOGIN
  lmSignInMainTitle: G_APP_NAME + " / Prijava",
  lmSignInWithGoogleBtn: "Gmail",
  lmSignInWithFacebookBtn: "Facebook",
  lmSignInWithClassicBtn: "Klasično",
  lmSignInLoginBtn: "Prijava",
  lmSignInForgottenPass: "Pozabljeno geslo?",
  lmSignInNewUser: "Ustvari novega uporabnika",
  lmSignInResetPassword:
    "Povezava za spremembo gesla je bila poslana na vaš elektronski naslov.",
  lmSignInWelcomeMessage:
    "Dobrodošli v spletni trgovini. Prosim, izberite način prijave v sistem.",
  lmSignInLoadingMessage: "Prosim, počakajte trenutek ...",
  lmSignInCookieNotifyMessage:
    "Spletna stran uporablja piškotke, s pomočjo katerih poskrbimo za prijetnejšo uporabniško izkušnjo in zagotavljamo kakovost vsebin.",
  lmSignInCookieAgreeBtn: "Strinjam se",
  lmSignInFacebookInfo:
    "Trenutno se nahajate v Facebook ali Inastagram brskalniku, aplikacija pa za pravilno delovanje potrebuje zagon v privzetem brskalniku vaše naprave.",
  lmSignInFacebookInfo2:
    "Prosim, kliknite zgoraj desno na tri pike in iz menuja izberite možnost 'Odpri v aplikaciji ...' Hvala za razumevanje.",
  lmSignInPrivacyLinkTitle: "Zasebnost in varnost",
  lmSignInRulesLinkTitle: "Pogoji poslovanja",
  // FORM SIGNUP
  lmSignUpMainTitle: G_APP_NAME + " / Nov uporabnik",
  lmSignUpBackToLogin: "Nazaj na prijavo",
  lmSignUpConfirmBtn: "Ustvari račun",
  // TOOLBAR MENU USER PROFILE
  lmToolbarUserMenuItemEditSettings: "Nastavitve profila",
  lmToolbarUserMenuItemLogout: "Odjavi se",
  // TODO.VUE
  lmTodoMainTitle: "OPRAVKI",
  lmTodoWhatTodo: "Kaj moram še postoriti?",
  lmTodoFilterAll: "vsi",
  lmTodoFilterActive: "aktivni",
  lmTodoFilterDone: "opravljeni",
  lmTodoItemsLeft: "opravkov",
  lmTodoClearCompleted: "Odstrani opravljene",
  // DASHBOARD.VUE
  dashboardCardAdminSectionTitle: "Nadzorna plošča",
  dashboardCardAdminSectionSubTitle: "Urejanje naročil in nastavitev.",
  dashboardCardModulePhotoOrderTitle: "Naročila",
  dashboardCardModulePhotoOrderUserTitle: "Večni spomini",
  dashboardCardModulePhotoOrderUserSubTitle: "Razvijanje fotografij",
  dashboardCardModulePhotoGiftTitle: "Podarite nekaj posebnega",
  dashboardCardModulePhotoGiftSubTitle: "Foto izdelki",
  dashboardCardModuleExtraCostSubTitle: "Dodatni stroški",
  dashboardCardModulePhotoOrderUserOrderButtonTitle: "Nov paket",
  dashboardCardModulePhotoGiftOrderButtonTitle: "Nov izdelek",
  dashboardCardModulePhotoOrderPricesButtonTitle: "Cenik",
  dashboardCardAddClientSuperAdminTitle: "Trgovine",
  dashboardCardActionsDiscountsTitle: "Akcije in popusti",
  dashboardCardSuperAdminTitle: "Nastavitve",
  dashboardCardSuperAdminSubTitle: "Podrobne nastavitve trgovine",
  dashboardCardSuperAdminDelivery: "Prevzemna mesta",
  dashboardCardSuperAdminGiftCardTemplate: "Predloge darilnih bonov",
  dashboardCardSuperAdminGiftCardActive: "Aktivni darilni boni",
  dashboardCardSuperAdminGiftCardCategory: "Kategorije darilnih bonov",
  dashboardCardSuperAdminPromoCodes: "Promocijske kode",
  dashboardCardSuperAdminImageTemplate: "Slikovne predloge",
  dashboardCardSuperAdminColors: "Barvna tema",
  dashboardCardSuperAdminBasicSettings: "Nastavitve kartice",
  dashboardCardSuperAdminImageSizes: "Velikosti slik",
  dashboardCardSuperAdminImageDiscounts: "Količinski popusti",
  dashboardCardSuperAdminPaperType: "Vrste papirja",
  dashboardCardSuperAdminUserRights: "Pravice uporabnikov",
  dashboardCardSuperAdminOther: "Nastavitve trgovine",
  dashboardCardSuperAdminProducts: "Izdelki",
  dashboardCardSuperAdminProductsCategory: "Kategorije izdelkov",
  dashboardCardSuperAdminAppStatistics: "Statistika",
  dashboardCardSuperAdminPhotoGiftCategory: "Kategorije izdelkov",
  dashboardCardSuperAdminPhotoGiftSuperCategory: "Glavne kategorije",
  dashboardCardSuperAdminPhotoGift: "Izdelki",
  dashboardCardSuperAdminBackgroundsCatDatabase: "Kategorije ozadij",
  dashboardCardSuperAdminBackgroundsDatabase: "Ozadja",
  dashboardCardSuperAdminPatternsCatDatabase: "Kategorije vzorcev",
  dashboardCardSuperAdminPatternsDatabase: "Vzorci",
  dashboardCardSuperAdminFramesCatDatabase: "Kategorije okvirjev",
  dashboardCardSuperAdminFramesDatabase: "Okvirji",
  dashboardCardSuperAdminStickersCatDatabase: "Kategorije nalepk",
  dashboardCardSuperAdminStickersDatabase: "Nalepke",
  dashboardCardUserSettingsTitle: "Nastavitve uporabnika",
  dashboardCardUserSettingsSubTitle:
    "Tukaj lahko uredite podatke o vašem profilu.",
  dashboardCardUserSettingsSubTitleUnknownUser: "Neznani uporabnik",
  dashboardCardUserSettingsUpdateProfileWarning:
    "Prosim, dopolnite podatke profila",
  dashboardCardUserSettingsUpdateButtonTitle: "Uredi profil",
  dashboardCardUserOrdersTitle: "Naročila",
  dashboardCardUserNewOrderTitle: "Novo naročilo",
  dashboardCardAdminActivePackagesViewTitle: "Vse dostavne enote",
  // HOMEMENUACTIVEPROMOTIONS.VUE
  homeMenuActivePromotionsPart1Text: "Izkoristite kodo",
  homeMenuActivePromotionsPart2Text: "ter prihranite",
  homeMenuActivePromotionsPart3Text: " pri klasičnem razvijanju slik",
  homeMenuActivePromotionsPart3bText: " pri naročilu foto izdelkov",
  homeMenuActivePromotionsPart3cText: " pri naročilu foto izdelka",
  homeMenuActivePromotionsPart3dText: " pri naročilu izdelkov kategorije",
  homeMenuActivePromotionsPart3aText: " pri celotnem naročilu",
  homeMenuActivePromotionsPart4aText: " Kodo lahko uporabite le enkrat.",
  homeMenuActivePromotionsPart4bText: " Kodo lahko uporabite večkrat.",
  // USERORDERS.VUE
  userOrdersEmptyMsg: "Trenutno nimate aktivnih naročil.",
  userOrdersCancelOrderBtn: "Prekliči naročilo",
  userOrdersCancelOrderQuestion: "Ali resnično želite preklicati naročilo ",
  userOrdersCloseOrderBtn: "To naročilo sem že prevzel-a",
  userOrdersCloseOrderSucess: "Naročilo je bilo  uspešno odstranjeno.",
  userOrdersCloseOrderError: "Napaka pri odstranjevanju zapisa.",
  userOrdersStatus0Title: "Čaka",
  userOrdersStatus1Title: "V izdelavi",
  userOrdersStatus2Title: "Narejeno",
  userOrdersStatus3Title: "Zaključeno",
  userOrdersStatus3aTitle: "Prevzeto",
  userOrdersStatus3bTitle: "Oddano",
  userOrdersPackagesList: "Podrobnosti",
  userOrdersDisplayList: "Prikaži",
  userOrdersNewSearchList: "Iskanje",
  userOrdersNewSearchList2: "Iskanje naročila",
  userOrdersUserDataList: "Podatki o stranki",
  userOrdersAdminWorkList: "Povezani z naročilom",
  userOrdersMessages: "Sporočilo studiu",
  userOrdersDateViewLast7: "Zadnjih 7 dni",
  userOrdersDateViewLast30: "Zadnjih 30 dni",
  userOrdersDateViewLast90: "Zadnjih 90 dni",
  userOrdersDateYear: "Leto",
  userOrdersCustomSearch: "Išči določeno naročilo",
  userOrdersModPhotoOrderSummary: "Povzetek razvijanja fotografij",
  userOrdersModPhotoGiftSummary: "Povzetek foto izdelkov",
  userOrdersFullSummary: "Znesek za plačilo",
  userOrdersIncludesTax: "Vse cene vključujejo",
  userOrdersPayedFullSummary: "Vrednost naročila",
  userOrdersSendEmailSubject: "Novo naročilo",
  userOrdersSendEmailPrepaySubject: "predračun",
  userOrdersSendEmailReferenceSubject: "Sklic predračuna",
  userOrdersCompleteSendEmailSubject: "Vaše naročilo",
  userOrdersCompleteSendEmailSubject2: "je pripravljeno!",
  userOrdersMessageForStudio: "Sporočilo studiu",
  userOrdersSendEmailPrepayHeaderTitle: "Podatki za plačilo predračuna",
  userOrdersTotalNum: "Skupno št. naročil",
  userOrdersTotalSum: "Skupni znesek",
  // HOMEMENUADMINSTATS
  homeMenuAdminStatsMainTitle: "Hitra statistika",
  homeMenuAdminStatsTodayTitle: "Danes",
  homeMenuAdminStatsLastDaysTitle: "Zadnjih 7 dni",
  homeMenuAdminStatsLastMonthTitle: "Ta mesec",
  homeMenuAdminStatsNoGraphTitle: "Graf bo na voljo jutri.",
  homeMenuAdminStatsCurrentSubscriptionAmountTitle:
    "Trenutni mesečni znesek najemnine znaša",
  // HOMEMENUADMINPACKAGES
  homeMenuAdminPackagesTemporaryPackages: "Rezervne povezave do paketov",
  homeMenuAdminPackagesMultipleRecipients: "Več naslovnikov",
  homeMenuAdminPackagesBtnDoneSelection: "Označi za narejeno",
  homeMenuAdminPackagesBtnDeliveredSelection: "Označi za prevzeto",
  homeMenuAdminPackagesSelection: "Izbranih elementov",
  homeMenuAdminPackagesNoMessages: "Ni sporočil.",
  homeMenuAdminPackagesSendExtraEmailStudio: "Sporočilo o naročilu",
  homeMenuAdminPackagesSendExtraEmailMsg1: "To je računalniško generirano sporočilo, zato nanj ne odgovarjajte! Če želite odgovoriti, to lahko storite v naši aplikaciji. Po prijavi kliknite gumb Naročila, kliknite na vaše naročilo in nato kliknite gumb Novo sporočilo.",
  homeMenuAdminPackagesSendExtraEmail: "Pošlji dodatni email",
  homeMenuAdminPackagesSendExtraEmailRecipient: "Naslovnik",
  homeMenuAdminPackagesCustomer: "Stranka",
  homeMenuAdminPackagesEmptyMsg: "Trenutno ni novih ali aktivnih naročil.",
  homeMenuAdminPackagesNotificationQuestionWarningTitle:
    "Ob oznaki NAREJENO bodo paketi slik, ki pripadajo temu naročilu, trajno izbrisani iz strežika.",
  homeMenuAdminPackagesNotificationQuestionTitle:
    "Pošlji obvestilo stranki o pripravljenem naročilu?",
  homeMenuAdminPackagesDeleteFromStorageTitle:
    "Ob zapiranju naročila bodo v arhivu ostali vsi podatki o tem naročilu, paketi slik pa bodo trajno izbrisani.",
  homeMenuAdminPackagesInternalNoteTitle: "Dodaj interni zaznamek k naročilu",
  homeMenuAdminPackagesInternalNoteDeleteTitle: "Izbriši interni zaznamek",
  homeMenuAdminPackagesInternalNoteDeleteBodyTitle: "Ali resnično želite izbrisati izbrani interni zaznamek?",
  // HOMEMENUCARTINFO.VUE
  homeMenuCartInfoEmpty: "Nakupovalna košarica je prazna.",
  homeMenuCartInfoCartTitle: "Košarica",
  homeMenuCartInfoCashierTitle: "Blagajna",
  homeMenuCartInfoOrderStatusTitle: "Naročila",
  homeMenuCartInfoAddImagesTitle: "Dodaj slike",
  homeMenuCartInfoActiveModeratorsTitle: "Vprašajte nas karkoli",
  homeMenuCartInfoActiveUserRoomsTitle: "Aktivni pogovori",
  homeMenuCartInfoFirstMessageTitle: "Pozdravljeni, kako vam lahko pomagam?",
  homeMenuCartInfoSendEmailTitle: "Prosim, napišite sporočilo",
  homeMenuCartInfoSendMessageTitle: "Napišite sporočilo ...",
  homeMenuCartInfoSendEmailSuccessTitle: "Sporočilo je bilo poslano.",
  homeMenuCartInfoSendMsgSuccessTitle: "Sporočilo je bilo dodano.",
  homeMenuCartInfoRemoveMsgSuccessTitle: "Sporočilo je bilo odstranjeno.",
  homeMenuCartInfoSendMsgErrorTitle: "Sporočilo ni bilo dodano.",
  homeMenuCartInfoRemoveMsgErrorTitle: "Sporočilo ni bilo odstranjeno.",
  homeMenuCartInfoSendEmailErrorTitle: "Prišlo je do napake pri pošiljanju.",
  homeMenuCartInfoSendEmailSubjectTitle: "APP | Sporočilo od: ",
  homeMenuCartInfoCancelOrderEmailSubjectTitle: "Preklic naročila: ",
  homeMenuCartInfoCancelOrderEmailSubjectBody1: " je preklical-a naročilo  ",
  homeMenuCartInfoCloseChatButtonTitle: "Zaključi pogovor",
  homeMenuCartInfoActionButtonWelcomeTitle: "Kaj lahko storimo za vas?",
  // HOMEMENUADMINARCHIVE
  homeMenuAdminArchiveTitle: "Arhiv naročil",
  homeMenuAdminArchiveViewTitle: "Iskanje",
  homeMenuAdminArchiveViewSearchStrTitle: "Vpišite iskalni niz",
  homeMenuAdminArchiveSearchType: "Vrsta iskanja",
  homeMenuAdminArchiveSearchNoResults: "V arhivu ni naročil s takimi podatki.",
  homeMenuAdminArchiveSearchByOrderId: "Številka naročila",
  homeMenuAdminArchiveSearchByFullName: "Naziv stranke",
  homeMenuAdminArchiveSearchByEmail: "Email stranke",
  // GIFTCARD
  giftCardNewAdded: "Darilni bon iz naročila je bil dodan v bazo.",
  giftCardCodeTitle: "Koda",
  giftCardFullNameTitle: "Ime in priimek",
  giftCardAddress1Title: "Ulica in hišna številka",
  giftCardAddress2Title: "Poštna številka / Pošta",
  giftCardCountryTitle: "Država",
  giftCardEmailTitle: "Email",
  giftCardPhoneTitle: "Telefon",
  giftCardNotesTitle: "Opombe",
  giftCardValueTitle: "Vrednost",
  giftCardClosedTitle: "Uveljavljen",
  giftCardItemNameTitle: "Vrsta bona",
  giftCardValidToTitle: "Veljavnost",
  giftCardAddedDateTitle: "Dodano",
  giftCardCloseCardQuestionTitle: "Ali ste prepričani, da želite zapreti ta darilni bon?",
  // USERCART.VUE
  userCartUpdateProfileWarningTitle:
    "Blagajna bo omogočena, ko dopolnite podatke vašega profila.",
  userCartDetailsTitle: "Podrobnosti o izdelkih",
  userCartModPhotoOrdersTitle: "Razvijanje fotografij",
  userCartModPhotoOrdersMinOrderError: "Minimalni znesek naročila slik je",
  userCartModPhotoOrdersMinOrderError2: ". Če želite zaključiti naročilo morate dodati nov paket in dodati več slik.",
  userCartModPhotoOrderPackageTitle: "Paket slik",
  userCartModPhotoOrderAddMore1Title: "Dodajte",
  userCartModPhotoOrderAddMore2Title: "slik in prihranite dodatnih",
  userCartModPhotoGiftAddMore2Title: "izdelkov in prihranite dodatnih",
  userCartModPhotoGiftTitle: "Foto izdelki",
  userCartModPhotoGiftPackageTitle: "Izdelek",
  userCartStorageDeletionNotification:
    "Vaše naložene pakete hranimo na strežniku do 7 dni. Če v tem času ne zaključite naročila se avtomatsko odstranijo.",
  // USERCASHIER.VUE
  userCashierDeliveryTitle: "Način prevzema",
  userCashierDeliveryTypeTitle: "Način plačila",
  userCashierDeliveryTypePersonalTitle: "Osebno ob prevzemu",
  userCashierDeliveryTypePrepayTitle: "Po predračunu",
  userCashierDeliveryTypeAtDeliveryTitle: "Po povzetju",
  userCashierDeliveryTypeCardTitle: "Kreditna kartica",
  userCashierEditUserProfileTitle:
    "Za lažjo komunikacijo vas prosimo, da dopolnite manjkajoče osebne podatke.",
  userCashierDeliveryTypePrepayInfoTitle:
    "Na email boste prejeli predračun. Vaš paket bomo izdelali po prejetem nakazilu.",
  userCashierDeliveryTypeAtDeliveryInfoTitle:
    "Vaš paket bomo oddali na pošto s plačilom po povzetju. Kljub vračunani poštnini, lahko pride do dodatnih stroškov (ponavadi cca 1 EUR) s strani dostavljalca (provizija plačila), katere krijete sami. Če se želite temu izogniti, prosim izberite drugi način plačila.",
  userCashierFinalSumTitle: "Za plačilo",
  userCashierAddItemsTitle: "Dodaj izdelke",
  userCashierFinishOrderTitle: "Zaključi naročilo",
  userCashierFinalSumNullTitle: "Napaka pri izračunu končne vrednosti naročila. Prosim pojdite nazaj v košarico in poskusite ponovno.",
  userCashierAddressAndPhoneDataTitle: "Podatki za dostavo in obveščanje",
  userCashierPhoneDataTitle: "Podatki za obveščanje",
  userCashierMsgConfirm:
    "S potrditvijo boste oddali naročilo v izdelavo. Status naročil lahko spremljate v aplikaciji (naročila), o pripravljenosti naročila pa boste obveščeni na email oziroma telefon. Hvala za naročilo.",
  msgSuccessAddOrder: "Naročilo je bilo uspešno oddano.",
  userCashierAddMore1Title: "V košarico dodajte za",
  userCashierAddMore2Title: "izdelkov in prejmite popust",
  userCashierOrderIdTitle: "Št. naročila",
  userCashierEmailNewOrderStart:
    "<p>Pozdravljeni, hvala za vaše naročilo. Ko bo naročilo pripravljeno, vas bomo obvestili na email oziroma telefon.</p>",
  userCashierEmailNewOrderPrepayStart:
    "<p>Pozdravljeni, hvala za vaše naročilo. Naročilo bomo pripravili po plačanem predračunu, takrat boste obveščeni na email oziroma telefon. Za hitrejšo izdelavo naročila nam lahko pošljete potrditev o plačilu na [email].</p>",
  userCashierEmailOrderCompletedPersonalDelivery:
    "<p>Pozdravljeni, vaše naročilo je pripravljeno.</p><p>Naročeni izdelki vas čakajo na prevzemnem mestu [personal].</p>",
  userCashierEmailOrderCompletedPostDelivery:
    "<p>Pozdravljeni, vaše naročilo je pripravljeno.</p><p>Naročeni izdelki bodo oddani v dostavo v najkrajšem možnem času.</p>",
  userCashierQRCodePayment: "Plačilo predračuna",
  // UTILS/HOWLONGAGO FUNCTION
  fHowLongAgoNow: "pred nekaj sekundami",
  fHowLongAgoFewMinutes: "pred nekaj minutami",
  fHowLongAgoFewHours: "pred nekaj urami",
  fHowLongAgoFewDays: "pred nekaj dnevi",
  fHowLongAgoYesterday: "včeraj",
  fHowLongAgoPrefix: "pred ",
  fHowLongAgoMinSufix: " minutami",
  fHowLongAgoHourSufix: " urami",
  fHowLongAgoDaySufix: " dnevi",
  // SETTINGSSUBMENU.VUE
  settingsSubMenuAllTitle: "Celotno naročilo",
  settingsSubMenuModulePhotoOrderTitle: "Razvijanje fotografij",
  settingsSubMenuModulePhotoGiftTitle: "Foto izdelki",
  settingsSubMenuModuleGiftCardTitle: "Darilni boni",
  settingsSubMenuModuleUserSettingsTitle: "Uporabniške nastavitve",
  settingsSubMenuModuleImageDatabasesTitle: "Slikovne baze",
  settingsSubMenuModulePhotoOrderSubTitle:
    "Nastavitve modula za razvijanje fotografij",
  settingsSubMenuModuleUserSettingsSubTitle:
    "Nastavitve modula za uporabniške nastavitve",
  // SETTINGSDELIVERY.VUE
  settingsDeliveryGridHeaderDeliveryTitle: "Prevzemno mesto",
  settingsDeliveryGridHeaderPaymentTypesTitle: "Načini plačila",
  settingsDeliveryGridHeaderPaymentTypesShortTitle: "Plačilo",
  settingsDeliveryGridHeaderExtraPayTitle: "Doplačilo",
  settingsDeliveryGridHeaderExtraPayMessageTitle: "Naziv doplačila",
  settingsDeliveryGridHeaderExtraPayFreeOverTitle: "Brez doplačila nad",
  settingsDeliveryGridHeaderMinOrderTitle: "Minimalni znesek naročila",
  settingsDeliveryGridHeaderMapTitle: "Lokacija",
  settingsDeliveryGridHeaderEmailTitle: "Email",
  settingsDeliveryGridHeaderShowAddressTitle: "Pošta",
  settingsDeliveryGridHeaderMapHint:
    "Prilepite povezavo do lokacije (npr. Google maps)",
  // SETTINGSPRODUCTSCATEGORY.VUE
  settingsProductsGridHeaderProductCategoryTitle: "Kategorija",
  settingsProductsGridHeaderProductCategoryActiveTitle: "Aktivna",
  // SETTINGSPRODUCTS.VUE
  settingsProductsGridHeaderNameTitle: "Naziv",
  settingsProductsGridHeaderImageTitle: "Slika",
  settingsProductsGridHeaderDescriptionTitle: "Opis",
  settingsProductsGridHeaderPriceTitle: "Cena",
  settingsProductsGridHeaderhasFilesTitle: "Datoteke",
  settingsProductsGridHeaderCategoryTitle: "Kategorija",
  settingsProductsGridHeaderSubCategoryTitle: "Različice",
  settingsProductsGridHeaderSubCategoryHint:
    "Vpišite seznam različic izdelka, ločen z vejicami",
  // SETTINGSCOLOR.VUE
  settingsDeliveryPrimaryColorTitle: "Primarna",
  settingsDeliverySecondaryColorTitle: "Sekundara",
  settingsDeliveryAccentColorTitle: "Pomožna",
  // SETTINGSPHOTOORDERBASIC.VUE
  settingsPhotoOrderBasicSettingsTitle: "Osnovno",
  settingsPhotoOrderBasicApperanceTitle: "Izgled",
  settingsPhotoOrderBasicTaxTitle: "Davek (%)",
  settingsPhotoOrderBasicTitle: "Naslov",
  settingsPhotoOrderBasicSubTitle: "Podnaslov",
  settingsPhotoOrderBasicImage: "Slika (640x200px / jpg)",
  settingsPhotoOrderBasicWhiteText: "Svetlo besedilo",
  settingsPhotoOrderBasicEnableSimpleUploadTitle: "Omogoči pošiljanje originalnih slik",
  settingsPhotoOrderBasicEnableDateTitle: "Omogoči tiskanje datumov na slike",
  settingsPhotoOrderBasicEnableCropTitle: "Omogoči izrezovanje slik",
  settingsPhotoOrderBasicEnableAdvancedUploadTitle: "Omogoči klasično pošiljanje",
  settingsPhotoOrderBasicKeepOriginalFileNames: "Ohrani originalna imena datotek",
  // SETTINGSIMAGESIZE.VUE
  settingsImageCustomSizeTitle: "Slika po meri na velikost",
  settingsImageSizeGridHeaderNameTitle: "Velikost",
  settingsImageSizeGridHeaderNameFileTitle: "Naziv (dat.)",
  settingsImageSizeGridHeaderPriceTitle: "Cena",
  settingsImageSizeGridHeaderXTitle: "Širina (px)",
  settingsImageSizeGridHeaderYTitle: "Višina (px)",
  settingsImageSizePaperTypesTitle: "Papir",
  settingsImageSizeDefaultSizeTitle: "Privzeta velikost",
  // SETTINGSIMAGEDISCOUNTS.VUE
  settingsImageDiscountsGridHeaderQuantityTitle: "Št. slik",
  settingsImageDiscountsGridHeaderDiscountTitle: "Popust",
  // SETTINGSUSERRIGHTS.VUE
  settingsUserRightsisModerator: "Moderator",
  settingsUserRightsisAdmin: "Administrator",
  settingsUserRightsisSuperAdmin: "Super administrator",
  settingsUserRightsisSuperAdminCardTitle: "Uporabnik",
  settingsUserRightsisSuperAdminMsgNoEmail: "Vpisani email ne obstaja.",
  // SETTINGSOTHER.VUE
  settingsOtherOrderEnableQRCodeTitle: "Dodaj QR kodo",
  settingsOtherOrderPrintFontTitle: "Pisava",
  settingsOtherOrderPrintFontSizeTitle: "Velikost pisave",
  settingsOtherOrderPrintMaxWidthTitle: "Širina strani (px)",
  settingsOtherThisMonthTitle: "Ta mesec",
  settingsOtherThisYearTitle: "Letos",
  settingsOtherTodayTitle: "Danes",
  settingsOtherBasicSettingsCardTitle: "Osnovne nastavitve",
  settingsOtherEnvironmentSettingsCardTitle: "Nastavitve okolja",
  settingsOtherPrepaySettingsCardTitle: "Nastavitve predračuna",
  settingsOtherOrderPrintSettingsCardTitle: "Nastavitve tiskanja naročila",
  settingsOtherResponseSettingsCardTitle: "Nastavitve odzivnih sporočil",
  settingsOtherLoginSettingsCardTitle: "Nastavitve prijavne strani",
  settingsOtherRulesAndSecurityInfoCardTitle: "Nastavitve pogojev poslovanja in zasebnosti",
  settingsOtherShowCookiesInfoTitle: "Prikaži obvestilo o piškotkih",
  settingsOtherShowPrivacyInfoTitle: "Prikaži potrjevanje o varnosti in zasebnosti",
  settingsOtherShowRulesInfoTitle: "Prikaži pogoje poslovanja",
  settingsOtherPrivacyHTMLTitle: "Besedilo o varnosti in zasebnosti",
  settingsOtherRulesHTMLTitle: "Besedilo o pogojih poslovanja",
  settingsOtherCookiesHTMLTitle: "Piškotki",
  settingsOtherCurrencyCardTitle: "Plačilna valuta",
  settingsOtherTaxTitle: "Naziv davka",
  settingsOtherNumberFormatTitle: "Oblika zapisa števil",
  settingsOtherQRCodeFormatTitle: "Oblika QR kode",
  settingsOtherDigitsTitle: "Št. decimalnih mest",
  settingsOtherAutoResponseEmail: "Avtomatski odzivni email",
  settingsOtherDateFormatTitle: "Format datumov",
  settingsOtherLoginImageTitle: "Naključna prijavna slika",
  settingsOtherLoginImageKeywordTitle: "Kategorija prijavne slike",
  settingsOtherLoginImageStorageLinkTitle:
    "Vaša prijavna slika (cca 600x300px / jpg)",
  settingsOtherLogoImageStorageLinkTitle:
    "Vaš logotip (največ 48x48px / kvadraten / .png)",
  settingsOtherLoginBackgroundWelcomeMessageTitle: "Pozdravno sporočilo",
  settingsOtherLoginBackgroundColorTitle: "Barva ozadja",
  settingsOtherLoginBackgroundImageTitle: "Naključno ozadje",
  settingsOtherLoginBackgroundImageKeywordTitle: "Kategorija slike za ozadje",
  settingsOtherLoginBackgroundImageLinkTitle: "Povezava do vira ozadja",
  settingsOtherLoginBackgroundShadowTypeTitle: "Senčenje ozadja",
  settingsOtherLoginBackgroundShadowStrengthTitle: "Moč senčenja ozadja",
  settingsOtherFullNameTitle: "Ime trgovine",
  settingsOtherClientTitle: "Kratko ime",
  settingsOtherCompanyInfoTitle: "Podatki o podjetju",
  settingsOtherCompanyInfoTitleTitle: "Naziv podjetja",
  settingsOtherCompanyInfoAddress1Title: "Naslov podjetja",
  settingsOtherCompanyInfoAddress2Title: "Pošta",
  settingsOtherCompanyInfoAccountTitle: "TRR",
  settingsOtherActiveTitle: "Aktivna",
  settingsOtherVisibleTitle: "Vidna",
  settingsOtherPricingTitle: "Najemnina",
  settingsOtherBasePriceTitle: "Osnovna najemnina",
  settingsOtherBaseLimitTitle: "Vključeni promet",
  settingsOtherOverLimitPctTitle: "Delež nad vključenim prometom (%)",
  settingsOtherSubCalcTitle: "Znesek najemnine",
  settingsOtherCompanyInfoHintTitle:
    "Vpišite podatke za prikaz v glavi predračunov...",
  settingsOtherClientPunchlineTitle: "Slogan",
  settingsOtherLangTitle: "Privzeti jezik",
  settingsOtherThemeTitle: "Tema",
  settingsOtherThemeLightTitle: "Svetla",
  settingsOtherThemeDarkTitle: "Temna",
  settingsOtherCartExpireResponse:
    "<p>Pozdravljeni, v košarici naše aplikacije vas čakajo nezaključeni paketi. Če želite, da bodo izdelki narejeni, morate v košarici klikniti na gumb Blagajna in zaključiti naročilo.</p><p>Naloženi paketi se bodo v nasprotnem primeru samodejno odstranili čez 2 dni.</p><p>Hvala za razumevanje.</p>",
  settingsOtherCartExpireResponseTitle: "Obvestilo o odprtih paketih",
  settingsOtherNewOrderMsgTitle: "Obvestilo o novem naročilu",
  settingsOtherNewOrderPrepayMsgTitle:
    "Obvestilo o novem naročilu preko predračuna [email]",
  settingsOtherOrderCompletedPersonalTitle:
    "Obvestilo o pripravljenem naročilu (osebni prevzem) [personal]",
  settingsOtherOrderCompletedPostTitle:
    "Obvestilo o pripravljenem naročilu (po pošti)",
  // SETTINGSPROMOCODES.VUE
  settingsPromoCodesGridHeaderModuleTitle: "Modul",
  settingsPromoCodesGridHeaderValidFromTitle: "Velja od",
  settingsPromoCodesGridHeaderValidToTitle: "Velja do",
  settingsPromoCodesGridHeaderPromoCodeTitle: "Promo koda",
  settingsPromoCodesGridHeaderDiscountTitle: "Popust",
  settingsPromoCodesGridHeaderDiscountTypeTitle: "Tip popusta",
  settingsPromoCodesGridHeaderDiscountedItemTitle: "ID znižanega izdelka",
  settingsPromoCodesGridHeaderDiscountedItemMainTitle: "Popust na izdelku",
  settingsPromoCodesGridHeaderDiscountedSubItemTitle: "ID znižane različice",
  settingsPromoCodesGridHeaderDiscountedSubItemMainTitle: "Popust na različici",
  settingsPromoCodesGridHeaderDiscountedSuperCategoryTitle:
    "ID znižane glavne kategorije",
  settingsPromoCodesGridHeaderDiscountedSuperCategoryMainTitle:
    "Popust na glavni kategoriji",
  settingsPromoCodesGridHeaderDiscountedCategoryTitle: "ID znižane kategorije",
  settingsPromoCodesGridHeaderDiscountedCategoryMainTitle: "Popust na podkategoriji",
  settingsPromoCodesGridHeaderHiddenTitle: "Skrita",
  settingsPromoCodesGridHeaderPermanentTitle: "Večkratna",
  settingsPromoCodesDeleteOldInfoTitle:
    "Promo kode, ki so neaktivne več kot en mesec bodo avtomatsko izbrisane.",
  settingsPromoCodesDiscountedTypePct: "Procenti (%)",
  settingsPromoCodesDiscountedTypeAmt: "Znesek",
  // SETTINGSPAPERTYPE.VUE
  settingsPaperTypeGridHeaderPaperTypeTitle: "Vrsta papirja",
  settingsPaperTypeGridHeaderPaperTypeFileTitle: "Naziv (dat.)",
  settingsPaperTypeGridHeaderPriceTitle: "Doplačilo",
  settingsPaperTypeGridHeaderDefaultTitle: "Privzet",
  settingsPaperTypeGridHeaderActiveTitle: "Aktiven",
  // SETTINGSIMAGETEMPATE.VUE
  settingsImageTemplateBackMenuTypeNoneTitle: "Brez spodnje plasti",
  settingsImageTemplateOverlayMenuTypeNoneTitle: "Brez izrezne plasti",
  settingsImageTemplateMiddleMenuTypeNoneTitle: "Brez zgornje plasti",
  settingsImageTemplateCurrentItemTitle: "nastavitve elementa",
  settingsImageTemplateBackTitle: "spodnja plast",
  settingsImageTemplateImageTitle: "vmesna plast",
  settingsImageTemplateMiddleTitle: "zgornja plast",
  settingsImageTemplateEditTitle: "uporabniška plast",
  settingsImageTemplateOverlayTitle: "izrezna plast",
  settingsImageTemplateBackTypeNone: "Brez",
  settingsImageTemplateBackTypeImage: "Slika",
  settingsImageTemplateBackTypePattern: "Vzorec",
  settingsImageTemplateBackTypeColor: "Barva",
  settingsImageTemplateGHPermissionsTitle: "Dovoljenja",
  settingsImageTemplateGHAllowTransparentBackTitle:
    "Dovoli transparentno ozadje",
  settingsImageTemplateGHAllowBackgroundTitle: "Dovoli spreminjanje ozadja",
  settingsImageTemplateGHMainImageBackgroundTitle:
    "Slika ozadja ni glavna slika",
  settingsImageTemplateGHAllowImagesTitle: "Dovoli dodajanje slik",
  settingsImageTemplateGHAllowTextTitle: "Dovoli dodajanje besedila",
  settingsImageTemplateGHAllowFreeDrawingTitle: "Dovoli prosto risanje",
  settingsImageTemplateGHAllowStickersTitle: "Dovoli dodajanje nalepk",
  settingsImageTemplateGridHeaderPrivateTitle: "Zasebna",
  settingsImageTemplateGridHeaderLanguageTitle: "Jezik",
  settingsImageTemplateGridHeaderOrderTitle: "Vrstni red",
  settingsImageTemplateGridHeaderCodeTitle: "Koda",
  settingsImageTemplateGridHeaderTitleTitle: "Naziv",
  settingsImageTemplateGridHeaderWidthTitle: "Širina predloge",
  settingsImageTemplateGridHeaderHeightTitle: "Višina predloge",
  settingsImageTemplateGridHeaderDescriptionTitle: "Opis",
  settingsImageTemplateGridHeaderInstructionsTitle: "Pomoč uporabniku",
  settingsImageTemplateKeywordsTitle: "Podkategorija",
  settingsImageTemplateGridHeaderModuleTitle: "Modul",
  settingsImageTemplateGridHeaderActiveTitle: "Aktivna",
  settingsImageTemplateGridHeaderCreatedTimestampTitle: "Ustvarjeno",
  settingsImageTemplateGridHeaderEditedTimestampTitle: "Popravljeno",
  settingsImageTemplateGridHeaderPreviewImageTitle:
    "Predogled slika cca. 600x300px (jpg/png)",
  settingsImageTemplateGridHeaderAllowAutoPreviewTitle:
    "Avtomatska predogled slika",
  settingsImageTemplateGridHeaderPreviewImageShortTitle: "Predogled slika",
  settingsImageTemplateGridHeaderRulesTitle: "Definicija predloge",
  settingsImageTemplateGridHeaderRulesHint:
    "besedilno urejanje za izkušene uporabnike",
  settingsImageTemplateGridHeaderImageBgTitle: "Predloga ozadja (jpg/png)",
  settingsImageTemplateGridHeaderImageBgShortTitle: "Slika ozadja",
  settingsImageTemplateGridHeaderImageFgTitle: "Predloga ospredja (jpg/png)",
  settingsImageTemplateGridHeaderImageFgShortTitle: "Slika ospredja",
  settingsImageTemplateNoImageTitle: "Brez slike",
  settingsImageTemplateEditRulesTemplateBtnTitle: "Uredi predlogo",
  settingsImageTemplateErrorWrongDimensions:
    "Zapis dimenzij je napačen. Popravite ga v definiciji predloge (npr. 1200x900).",
  // SETTINGSIMAGEDATABASE.VUE
  settingsImageDatabaseOrderTitle: "Vrstni red",
  settingsImageDatabaseNameTitle: "Naziv",
  settingsImageDatabaseModuleTitle: "Modul",
  settingsImageDatabaseActiveTitle: "Aktivna",
  settingsImageDatabaseOwnerTitle: "Lastnik",
  settingsImageDatabaseRotateTitle: "Obojestranska",
  settingsImageDatabaseCategoryTitle: "Kategorija",
  settingsImageDatabaseKeywordsTitle: "Ključne besede",
  settingsImageDatabaseKeywordsHintTitle: "Ključne besede ločite z vejicami",
  settingsImageDatabaseImageTitle: "Slika",
  settingsImageDatabaseImageBatchTitle: "Ena ali več slik",
  settingsImageDatabaseLanguageTitle: "Jezik",
  settingsImageDatabaseDuplicateNameError:
    "Kategorija s tem imenom že obstaja!",
  settingsImageDatabasePropertiesTitle: "Lastnosti slike",
  // SETTINGSIMAGEDATABASECATEGORY.VUE
  settingsImageDatabaseCategoryOrderTitle: "Vrstni red",
  settingsImageDatabaseCategoryNameTitle: "Naziv",
  settingsImageDatabaseCategoryModuleTitle: "Modul",
  settingsImageDatabaseCategoryActiveTitle: "Aktivna",
  settingsImageDatabaseCategoryOwnerTitle: "Lastnik",
  // SETTINGSGIFTCARDTEMPLATE.VUE
  settingsGiftCardTemplateValidTitle: "Veljavnost",
  settingsGiftCardTemplateValidMonth: "1 mesec",
  settingsGiftCardTemplateValidTwoMonths: "2 meseca",
  settingsGiftCardTemplateValidThreeMonths: "3 meseci",
  settingsGiftCardTemplateValidSixMonths: "6 mesecev",
  settingsGiftCardTemplateValidYear: "1 leto",
  settingsGiftCardTemplateValidTwoYears: "2 leti",
  settingsGiftCardTemplateValidThreeYears: "3 leta",
  settingsGiftCardTemplateValidInfinite: "Neomejeno",
  // SETTINGSPHOTOGIFTCATEGORY.VUE
  settingsPhotoGiftCategoryOrderTitle: "Vrstni red",
  settingsPhotoGiftCategoryIdTitle: "Id",
  settingsPhotoGiftSuperCategoryTitle: "Kategorija",
  settingsPhotoGiftCategoryNameTitle: "Naziv",
  settingsPhotoGiftCategoryImageTitle: "Slika cca. 600x300px (jpg/png)",
  settingsPhotoGiftCategoryDescriptionTitle: "Opis",
  settingsPhotoGiftCategoryActiveTitle: "Aktivna",
  settingsPhotoGiftCategoryStepperStep1Title: "Izbor kategorije",
  settingsPhotoGiftCategoryStepperStep2Title: "Izbor izdelka",
  settingsPhotoGiftCategoryStepperStep3Title: "Izbor predloge",
  settingsPhotoGiftCategoryStepperStep4Title: "Urejanje",
  settingsPhotoGiftCategoryStepperStep5Title: "Prenos",
  // SETTINGSPHOTOGIFTSUPERCATEGORY.VUE
  settingsPhotoGiftSuperCategoryOrderTitle: "Vrstni red",
  settingsPhotoGiftSuperCategoryTitleTitle: "Naslov",
  settingsPhotoGiftSuperCategoryIdTitle: "Id",
  settingsPhotoGiftSuperCategorySubTitleTitle: "Podnaslov",
  settingsPhotoGiftSuperCategoryImageTitle: "Slika 800x250px (jpg)",
  settingsPhotoGiftSuperCategoryWhiteTextTitle: "Svetlo besedilo",
  settingsPhotoGiftSuperCategoryActiveTitle: "Aktivna",
  // SETTINGSPHOTOGIFT.VUE
  settingsPhotoGiftSuperTypeTitle: "Tip",
  settingsPhotoGiftSuperTypeItemTitle: "Izdelek",
  settingsPhotoGiftSuperTypeGiftTitle: "Foto izdelek",
  settingsPhotoGiftSuperTypeCollageTitle: "Foto kolaž",
  settingsPhotoGiftSuperTypeCustomTitle: "Posebna velikost",
  settingsPhotoGiftSuperTypeGiftCardTitle: "Darilni bon",
  settingsPhotoGiftSuperTypeLargePrintTitle: "Povečava",
  settingsPhotoGiftSuperTypePhotoCanvasTitle: "Foto platno",
  settingsPhotoGiftMinOrderShortTitle: "min.",
  settingsPhotoGiftMinOrderTitle: "Min. naročilo",
  settingsPhotoGiftMinTemplateClonesTitle: "Najmanj kopij",
  settingsPhotoGiftMaxTemplateClonesTitle: "Največ kopij",
  settingsPhotoGiftAllowTemplateClonesTitle: "Dovoli več kopij",
  settingsPhotoGiftSkipEditTitle: "Preskoči urejanje",
  settingsPhotoGiftValidToTitle: "Veljavnost",
  settingsPhotoGiftAllowCustomSizeTitle: "Dovoli poljubno velikost",
  settingsPhotoGiftOverrideSizeTitle: "Uveljavi lastno velikost predloge",
  settingsPhotoGiftOverrideSizeWidthTitle: "Uveljavljena širina (px)",
  settingsPhotoGiftOverrideSizeHeightTitle: "Uveljavljena višina (px)",
  settingsPhotoGiftEnableSmallDevicesTitle: "Omogoči na malih napravah",
  settingsPhotoGiftEnableSmallDevicesShortTitle: "Male naprave",
  settingsPhotoGiftEnableDeviceBasedEdit:
    "Omogoči omejeno oblikovanje glede na napravo",
  settingsPhotoGiftEnableDeviceBasedEditShort: "Omejeno oblikovanje",
  settingsPhotoGiftAddingExtraTemplateClonesTitle: "Dovoli dodajanje kopij",
  settingsPhotoGiftSendExtraEmailOnOrderTitle:
    "Ob naročilu pošlji dodatni email",
  settingsPhotoGiftOrderTitle: "Vrstni red",
  settingsPhotoGiftNameTitle: "Naziv",
  settingsPhotoGiftCodesTitle: "Povezane kode, ločene z |",
  settingsPhotoGiftDescriptionTitle: "Opis",
  settingsPhotoGiftIdTitle: "ID",
  settingsPhotoGiftImageTitle: "Slika cca. 600x300px (jpg/png)",
  settingsPhotoGiftImageTypeTitle: "Slika (kvadrat) maks. 200x200px (jpg/png)",
  settingsPhotoGiftImageSizeTitle: "Slika izdelka za predogled",
  settingsPhotoGiftActiveTitle: "Aktiven",
  settingsPhotoGiftCategoryTitle: "Kategorija",
  settingsPhotoGiftPriceTitle: "Cena",
  settingsPhotoGiftKeywordsTitle: "Podkategorije",
  settingsPhotoGiftInventoryTitle: "Zaloga",
  settingsPhotoGiftTypeTitle: "Različice",
  settingsPhotoGiftPrintSizeTitle: "Povezane predloge",
  settingsPhotoGiftType2Title: "Različica",
  settingsPhotoGiftCopiesTitle: "Št. kosov",
  settingsPhotoGiftSelectPhotoTitle: "Izberite fotografijo",
  settingsPhotoGiftDetailsTitle: "Podrobnosti naročila",
  settingsPhotoGiftUploadTitle: "Kreiranje naročila in dodajanje v košarico",
  settingsPhotoGiftFormNotCompleteErrorTitle:
    "Predloga ni pravilno izpolnjena. Prosim preverite ali ste izbrali vse slike in izpolnili tudi podrobnosti naročila.",
  settingsPhotoGiftFormInventoryErrorTitle:
    "Izbrali ste več izdelkov, kot jih je trenutno na zalogi. Največje možno število je",
  settingsPhotoGiftDefaultTemplateTitle: "Izpolni predlogo",
  settingsPhotoGiftPreviewImageCoodrinatesTitle: "Položaj slike na izdelku",
  // USERSETTINGS.VUE
  userSettingsPermissionsTitle: "Dovoljenja",
  userSettingsAdminTitle: "Administracija",
  userSettingsAdminShowPackagesTitle: "Prikaži pakete",
  userSettingsAdminSendNewPackageMessageTitle: "Obvestila o novih paketih",
  userSettingsallowFCMOrderNotificationTitle: "Dovoli obveščanje na to napravo",
  userSettingsallowFCMPromoNotificationTitle: "Direktno sporočilo o novostih",
  userSettingsallowEmailOrderNotificationTitle:
    "Obvestilo na email o stanju naročil",
  userSettingsallowEmailPromoNotificationTitle: "Obvestilo na email o novostih",
  userSettingsPersonalInfoTitle: "Osebni podatki",
  userSettingsCompanyInfoTitle: "Podatki o podjetju",
  userSettingsIsCompanyTitle: "Račun za podjetje",
  userSettingsVatNumberTitle: "Ident. št. za DDV",
  userSettingsFullNameTitle: "Ime in priimek",
  userSettingsAddress1Title: "Ulica in hišna št.",
  userSettingsAddress2Title: "Poštna št. in pošta",
  userSettingsCountryTitle: "Država",
  userSettingsPhoneTitle: "Telefon",
  userSettingsEmailTitle: "Email",
  userSettingsCompanyFullNameTitle: "Naziv podjetja",
  userSettingsCompanyAddress1Title: "Naslov podjetja",
  // USERGIFTNEWORDER.VUE
  userGiftNewOrderCropButtonTitle: "Ponovi izrez",
  userGiftNewOrderSaveButtonTitle: "Izreži",
  // USERNEWORDER.VUE
  userNewOrderSelectPhotosCardTitle: "Izberite fotografije",
  userNewOrderDefaultSettingsCardTitle: "Nastavitve naročila",
  userNewOrderDefaultSettingsCardSubTitle:
    "Izbor slik poteka tako, da najprej nastavite želeno velikost ter druge lastnosti (izrez, št. kopij, vrsta papirja... ) slik, ki jih želite naložiti. Nato kliknete v polje za izbor fotografij ter dodate slike iz vaše naprave. Izbrane slike se bodo pripele v naročilo z lastnostmi, ki ste jih nastavili. Če ste z izborom končali, pritisnete gumb Naprej. Če pa želite naročilu dodati več slik z drugimi lastnostmi (druga velikost, drug papir ipd.), ustrezno prilagodite Nastavitve naročila, ter ponovno kliknite v polje za izbor fotografij. Ko ste z izborom zadovoljni, kliknite gumb Naprej.",
  userNewOrderDefaultSettingsCardSubTitle2:
    "Na naslednji strani (predogled slik) boste lahko vsaki sliki lastnosti še dodatno prilagodili.",
  userNewOrderAddToCartHelp:
    "Dodajanje v košarico združi izbrane slike v paket ter ga prenese na strežnik. Tukaj ne bo še nič zaračunano. Naložene pakete lahko pogledate v Košarici na prvi strani, kjer tudi zaključite naročilo. Nasvet: dodate lahko neomejeno število paketov, pri čemer niste omejeni na napravo. Enostavno odprite aplikacijo v brskalniku drugega telefona, tablice, osebnem računalniku katerekoli znamke ter naložite nove pakete slik, ter vse skupaj pošljete v enkratnem naročilu.",
  userNewOrderImageSizeSelectTitle: "Velikost",
  userNewOrderPaperTypeSelectTitle: "Papir",
  userNewOrderImageSelectPhotosHintTitle: "Dodaj slike v naročilo",
  userNewOrderImageFillTypeTitle: "Izberite način obrezave fotografij",
  userNewOrderImageFillType1Title: "Fill-IN",
  userNewOrderImageFillType2Title: "Fit-IN",
  userNewOrderImageCropTitle: "Izreži",
  userNewOrderImageEditTitle: "Uredi",
  userNewOrderImageBorderTitle: "Dodaj bel rob",
  userNewOrderImageDateTitle: "Natisni datum",
  userNewOrderAutoCorrectionTitle: "Avtokorekcija",
  userNewOrderImageBorderShortTitle: "Bel rob",
  userNewOrderImageDateShortTitle: "Datum",
  userNewOrderAutoCorrectionShortTitle: "Avtok.",
  userNewOrderBtnAddMoreTitle: "Dodaj",
  userNewOrderPreviewDialogTitle: "Predogled slik je v pripravi",
  userNewOrderStepperStep1Title: "Izbor",
  userNewOrderStepperStep2Title: "Obdelava",
  userNewOrderStepperStep3Title: "Zaključek",
  userNewOrderStepperStep4Title: "Prenašanje",
  userNewOrderSummary1Title: "Povzetek paketa",
  userNewOrderSummary1aTitle: "Skupaj slik",
  userNewOrderSummary2Title: "Znesek paketov",
  userNewOrderSummary3Title: "Količinski popust",
  userNewOrderSummary4Title: "Znesek s količinskim popustom",
  userNewOrderSummary5Title: "Promo popust",
  userNewOrderSummary5cTitle: "Znesek s promo popustom",
  userNewOrderSummary5dTitle: "Znesek celotnega promo popusta",
  userNewOrderSummary5aTitle: "Koda",
  userNewOrderSummary5bTitle: "Velja za ",
  userNewOrderSummary5PromptTitle: "Promocijska koda",
  userNewOrderSummary6Title: "Znesek naročila",
  userNewOrderSummaryExtraChargeTitle: "Znesek z doplačilom",
  userNewOrderSummaryAddInfoTitle:
    "Morebitni stroški rokovanja z naročilom ter poštnina se obračunajo na blagajni.",
  userNewOrderSummaryDeliveryTitle: "Podatki za prevzem",
  userNewOrderSummaryDeliveryPromptTitle: "Izberite način prevzema",
  userNewOrderSummaryStudioInfoTitle: "Imate sporočilo za nas?",
  userNewOrderPreparingPackageTitle: "Priprava paketa za pošiljanje",
  userNewOrderPleaseWaitTitle: "Prosim, počakajte",
  userNewOrderOrderSending1Title: "Poteka pošiljanje paketa",
  userNewOrderOrderSending2Title:
    "Do zaključka prenosa prosim ne zapirajte aplikacije",
  userNewOrderOrderComplete1Title:
    "Če želite zaključiti naročilo, v košarici kliknite gumb BLAGAJNA, kjer izberete še način prevzema in plačila ter zaključite nakup.",
  userNewOrderOrderComplete2Title: "Paket je bil dodan v košarico",
  userNewOrderOrderCompleteGiftCardTitle: "Darilni bon je bil dodan v košarico",
  userNewOrderNoPaperTypeForSelectedFormat:
    "Izbrani papir ni na voljo za ta format. Prosim, izberite drug papir.",
  userNewOrderNoPaperTypeForSelectedFormatShort: "Izberite papir",
  userNewOrderNumOfErrors: "Število napak v naročilu: ",
  userNewOrderPaperTypeExtraPay: "Doplačilo: ",
  userNewOrderPaperTypeNoExtraPay: "Papir",
  userNewOrderPcsHint: "Kopij",
  userNewOrderFillInHint: "Izrez",
  userNewOrderImageSizeHint: "Velikost",
  userNewOrderPreviewTitle: "Predogled slike",
  userNewOrderImageTitle: "Slika",
  // USERNEWPHOTOGIFTORDER.VUE
  userNewPhotoGiftOrderCropTitle: "Prilagoditev slike",
  userNewPhotoGiftOrderSelectTypeTitle: "Izberite različico",
  userNewPhotoGiftOrderLoadingMiddleImage: "Nalagam zgornjo slikovno plast",
  userNewPhotoGiftOrderLoadingOverlayImage: "Nalagam izrezno slikovno plast",
  userNewPhotoGiftOrderLoadingBackgroundImage: "Nalagam slikovno plast ozadja",
  userNewPhotoGiftOrderLoadingTemplateImage: "Nalagam sliko predloge",
  userNewPhotoGiftOrderLoadingTemplateImages: "Nalagam slike predloge",
  userNewPhotoGiftOrderLoadingSimpleTemplateImage: "Nalagam preprosto sliko",
  userNewPhotoGiftOrderLoadingText: "Nalagam besedila predloge",
  userNewPhotoGiftOrderLoadingStickers: "Nalagam nalepke predloge",
  userNewPhotoGiftOrderLoadingError:
    "Prišlo je do napake pri nalaganju predloge. Kliknite gumb reset za ponovno nalaganje.",
  userNewPhotoGiftOrderLoadingImageError:
    "Napaka pri nalaganju slike. Prosim, poskusite ponovno.",
  userNewPhotoGiftOrderLoadingSuccess:
    "Predloga naložena. Lahko pričnete z urejanjem.",
  userNewPhotoGiftOrderFinalizeError:
    "Vse predloge tega izdelka še niso oblikovane, prosim preglejte naročilo.",
  // VUECROPPER
  vueCropperHighQuality: "Visoka kakovost slike",
  vueCropperMiddleQuality: "Srednja kakovost slike",
  vueCropperLowQuality: "Nizka kakovost slike",
  vueCropperVeryLowQuality: "Zelo nizka kakovost slike",
  // USERNEWPHOTOGIFTORDERDESIGN.VUE
  userNewPhotoGiftOrderDesignTitle: "Oblikovanje izdelka",
  userNewPhotoGiftOrderDesignResetQuestion:
    "Resetiram trenutno predlogo na začetno postavitev?",
  userNewPhotoGiftOrderDesignItemPreview: "Na izdelku",
  userNewPhotoGiftOrderDesignInstructions: "Navodila",
  userNewPhotoGiftOrderDesignFinalize: "Zaključek",
  userNewPhotoGiftOrderDesignMultiple: "Dodaj novo",
  userNewPhotoGiftOrderDesignReEdit: "Ponovno uredi",
  userNewPhotoGiftOrderDesignChangeTabQuestion:
    "Zaključim urejenje trenutne predloge?",
  userNewPhotoGiftOrderDesignFinalizeQuestion:
    "Želite zaključiti urejanje izdelka in dodati izdelek v košarico?",
  userNewPhotoGiftOrderDesignFinalizeMultipleQuestion:
    "Želite zaključiti naročilo ali oblikovati še kakšen izdelek te vrste?",
  userNewPhotoGiftOrderDesignFinalizeMultipleToGo:
    "Za dokončanje tega izdelka morate dodati še",
  userNewPhotoGiftOrderDesignFinalizeMultipleToGoEnd: "Izdelek je pripravljen.",
  userNewPhotoGiftOrderDesignFinalizeMultipleBtn1: "Nazaj",
  userNewPhotoGiftOrderDesignFinalizeMultipleBtn2: "Dodaj izdelek",
  userNewPhotoGiftOrderDesignFinalizeMultipleBody: "Trenutni izdelki v paketu",
  userNewPhotoGiftOrderDesignFinalizeMultipleBtn3: "Zaključi vse",
  userNewPhotoGiftOrderDesignSimpleError:
    "Predloga ni pravilno izpolnjena. Prosim, izberite manjkajoče slike.",
  userNewPhotoGiftOrderDesignSimpleError2:
    "Predloga je prazna. Prosim, dodajte vsaj eno sliko, ali kakšen drug element na predlogo.",
  userNewPhotoGiftOrderDesignSwipeInfo:
    "Za premik na naslednjo predlogo, podrsajte po ekranu v levo (swipe left). To lahko storite kjerkoli na zaslonu, razen na predlogi za urejanje.",
  userNewPhotoGiftOrderDesignSwipeRightError: "Nahajate se na prvi predlogi.",
  userNewPhotoGiftOrderDesignMaxCanvasError1:
    "Zaradi velikosti predloge je omogočeno le dodajanje ene slike.",
  userNewPhotoGiftOrderDesignMaxCanvasError2:
    "Zaradi velikosti predloge so možne težave pri oblikovanju izdelka na vaši napravi. V tem primeru izdelek oblikujte na zmogljivejši napravi. Hvala za razumevanje.",
  // USERNEWPHOTOGIFTORDERFINALIZE.VUE
  userNewPhotoGiftOrderFinalizeTitle: "Zaključek naročila",
  userNewPhotoGiftOrderFinalizeFormError:
    "Prosim, izpolnite vsa zahtevana polja pred oddajo naročila.",
  // USERNEWORDERBASIC.VUE
  userNewOrderBasicChangeSettings: "Spremeni nastavitve",
  userNewOrderBasicOrderCompleted: "Dodajanje je zaključeno",
  userNewOrderBasicBtnCancelOrder: "Prekliči nalaganje",
  userNewOrderBasicNewPackage: "Nov paket",
  userNewOrderBasicBtnAdd: "Dodaj več",
  userNewOrderBasicBtnUpload: "Zaključi",
  userNewOrderBasicMainTitle: "Nov paket",
  userNewOrderBasicMainMenuTitle: "Nastavitve dodajanja",
  userNewOrderBasicNotCroppedImages:
    "slikam še niste določili izreza Lahko pošljete tudi neizrezane slike in jim bomo izrez določili v studiu, vendar reklamacije na naš izrez niso možne.",
  userNewOrderBasicInitial1: "Kliknite tukaj za izbor slik.",
  userNewOrderBasicInitial2: "Dodali boste slike velikosti",
  userNewOrderBasicInitial3:
    "Pred dodajanjem spodaj preverite ali imate izbrane želene lastnosti slik.",
  userNewOrderBasicSelectFormatInfo:
    "Ob spremembi formata slike boste morali ponoviti izrez in morebitne dodatne učinke.",
  userNewOrderBasicSelectDateInfo:
    "Ob dodajanju datuma boste morali ponoviti izrez in morebitne dodatne učinke. Želite nadaljevati?",
  userNewOrderBasicSettingsTitle: "Nastavitve dodajanja",
  userNewOrderBasicSettingsHelp1Title:
    "Najprej prilagodite nastavitve dodajanja, potem pa spodaj izberite želeni način pošiljanja fotografij.",
  userNewOrderBasicSingleEditTitle: "Izrez slike",
  userNewOrderBasicSimpleUploadTitle: "Kliknite tukaj za pošiljanje originalnih slik",
  userNewOrderBasicSimpleUploadDetail1Title:
    "za profesionalne slike in največjo kakovost",
  userNewOrderBasicSimpleUploadDetail2Title:
    "večja velikost paketa, daljši prenos",
  userNewOrderBasicSimpleUploadDetail3Title: "brez predogleda in urejanja",
  userNewOrderBasicAdvancedUploadTitle: "Kliknite tukaj za klasično pošiljanje",
  userNewOrderBasicAdvancedUploadDetail0Title:
    "za običajne slike iz telefonov in foto aparatov",
  userNewOrderBasicAdvancedUploadDetail1Title:
    "predogled in možnost urejanja slik",
  userNewOrderBasicAdvancedUploadDetail2Title:
    "majhna velikost paketa, krajši prenos",
  userNewOrderBasicSettingsHelpTitle: "Kaj pomenijo nekatere nastavitve?",
  userNewOrderBasicOldWarningTitle: "Koliko slik lahko naložim v enem paketu?",
  userNewOrderBasicOldWarning:
    "Količina slik, ki jo lahko naenkrat pošljete v enem paketu je odvisna od velikosti vaših fotografij ter količine pomnilnika, ki je na voljo spletnemu brskalniku.",
  userNewOrderBasicOldWarning2:
    "Zato vas aplikacija opozori na morebitno omejitev (manjša na mobilnih napravah, večja na osebnih računalnikih). Ker pa število poslanih paketov ni omejeno, lahko naložite več paketov in na blagajni vse skupaj zaključite kot eno naročilo.",
  userNewOrderBasicOldWarning3:
    "Pakete lahko nalagate iz vseh naprav pod istim uporabniškim imenom in tako v enem naročilu pošljete slike iz vseh telefonov, računalnikov ali tablic brez zamudnega kopiranja med napravami.",
  userNewOrderBasicGoBack: "Ali resnično želite prekiniti naročilo?",
  userNewOrderBasicGoBack2:
    "Ali resnično želite prekiniti oblikovanje naročila in se vrniti nazaj na začetni zaslon?",
  userNewOrderBasicGoUpload: "Želite dodati slike v košarico?",
  userNewOrderBasicPackageFull:
    "Paket slik je poln. Če želite poslati več slik, najprej pošljite trenutni paket in nato ustvarite novega.",
  userNewOrderBasicSingleSettingsTitle: "Nastavitve slike",
  userNewOrderBasicSettingsHelpFillInTitle: "Izrez FILL-IN / FIT-IN",
  userNewOrderBasicSettingsHelpFillIn:
    "Velika večina slik se izdela na način FILL-IN, zato je to tudi privzeta nastavitev naročila. Točen izrez nastavimo v studiu, kjer se potrudimo, da zajamemo bistvo slike, osebe ali predmeta. Če ocenimo, da to ni mogoče, recimo pri slikah, ker so osebe na obeh robovih slik, sliko spremenimo v FIT-IN.",
  userNewOrderBasicSettingsHelpDate:
    "Datum je natisnjen na sredini daljšega roba slike. Nekatere slike podatka o datumu ne vsebujejo in ga zato na slikah ne moremo izpisati. Nekateri programi za obdelavo slik ob shranjevanju prepišejo datum nastanka fotografije, zato se lahko izpis datuma na sliki ne ujema z datumom nastanka.",
  userNewOrderBasicSettingsHelpBR:
    "Sliki se neglede na izbor formata, izreza ali datuma doda tanek bel rob okrog slike. Pogosto se uporablja pri vabilih in čestitkah.",
  userNewOrderBasicSettingsHelpAC:
    "Avtokorekcija pravilno osvetli in izostri posnetke, zato priporočamo, da je vklopljena za vse vaše domače slike, ki niso bile profesionalno obdelane in pripravljene za tisk. Za profesionalne slike pa avtokorekcijo izklopite, da bodo slike natisnjene tako, kot jih je pripravil vaš fotograf.",
  userNewOrderBasicDateOK: "Ali je datum pravilen?",
  userNewOrderBasicDateWarning: "Pomembno! Na vsaj eni fotografiji ste označili tiskanje datuma. Priporočamo, da pred pošiljanjem še enkrat preverite vsako fotografijo, če ji datum ustreza, sicer ga raje odstranite, ker ko paket naložite na strežnik, datuma ni več mogoče spremeniti.",
  userNewOrderBasicUploadEmptyWarning: "Nekaj slik aplikacija ni uspela prebrati, zato bodo ob nalaganju odstranjene iz paketa.",
  userNewOrderBasicHeicConversion: "Zahtevnejše pretvarjanje",
  // COMMON NEW ORDER
  commonNewOrderZipGenerationError: "Pri ustvarjanju paketa je prišlo do napake.",
  commonNewOrderAddRecordError: "Pri dodajanju zapisa je prišlo do napake.",
  commonNewOrderOrderAddToCartTitle: "Dodaj v košarico",
  commonNewOrderOrderFinalizeAllTitle: "Zaključi vse",
  commonNewOrderOrderEndShoppingTitle: "Košarica",
  commonNewOrderOrderContinueShoppingTitle: "Nadaljuj z nakupi",
  //USERNEWORDERSELECT.VUE
  userNewOrderSelectType: "izberite način",
  userNewOrderSelectSimpleType: "Izberi & pošlji (enostavno)",
  userNewOrderSelectSimpleTypeDesc:
    "Enostavneje ne gre. Izberite slike in jih pošljite. Za vse ostalo poskrbimo mi.",
  userNewOrderSelectAdvancedType: "Uredi & pošlji (zahtevnejše)",
  userNewOrderSelectAdvancedTypeDesc:
    "Izbrane slike preglejte in obrežite na želeno velikost. Slike bodo natisnjene povsem po vaših željah.",
  // APP UPDATE
  appUpdateDialogTitle: "Posodobitev aplikacije",
  appUpdateDialogBody:
    "Trenutna različica aplikacije na vaši napravi ni najnovejša. Priporočamo, da s klikom na gumb DA posodobite aplikacijo. Posodobitev traja le nekaj sekund.",
  // APP CONFIRMATIONS DIALOG
  appConfirmationsTitle: "Splošni pogoji uporabe",
  appConfirmationsPrivacyTitle: "Soglašam, da se nekateri moji osebni podatki shranijo za namen priprave naročil in obvestil",
  appConfirmationsRulesTitle: "Strinjam se s pogoji poslovanja trgovine",
  appConfirmationsCookiesTitle: "Soglašam, da aplikacija uporablja piškotke za izboljšanje uporabniške izkušnje",
  // STATS VUE
  statsModeTitle: "Način",
  statsModeDay: "Dnevni",
  statsModeMonth: "Mesečni",
  statsModeYear: "Letni",
  statsTotalSum: "Skupaj",
  statsSummaryTitle: "Povzetek",
  statsDevelopImagesTitle: "Fotografije",
  statsPhotoItemsTitle: "Foto izdelki",
  statsExtraCostsTitle: "Dodatni stroški",
  statsItemCopiesTitle: "Izdelkov",
  statsOrderNumTitle: "Naročil",
  statsOrderNumCompany: "Naročila za podjetja",
  statsOrderNumPaymentCard: "Plačilo s kreditno kartico",
  statsOrderNumPaymentDelivery: "Plačilo po povzetju",
  statsOrderNumPaymentPersonal: "Osebni prevzem",
  statsOrderNumPaymentPrepay: "Plačilo po predračunu",
  statsOrderNumPost: "Naročil po pošti",
  statsOrderNumPromoCode: "Naročil s promo kodo",
  statsTotalCopies: "Fotografij",
  userNewOrderBasicBtnSkipFile: "Preskoči to datoteko"
};
